// extracted by mini-css-extract-plugin
export default {"mainContainer":"error_mainContainer__2R7K1"};